<template>
    <div class="bg-color">
        <Navbar />
        <Header :category="'visitors'" :bannerTitle="bannerTitle" :breadCrumb="borrowSpaceCrumb" />
        <IndustryContent />
        <FooterTop />
        <FooterBottom />
    </div>
</template>

<script>
    import Navbar from 'components/DefaultHome/Layout/NavbarStyleTwo'
    import Header from 'components/DefaultHome/KECC5G/Common/Header'
    import IndustryContent from './IndustryContent'
    import FooterTop from 'components/DefaultHome/Layout/FooterTop'
    import FooterBottom from 'components/DefaultHome/Layout/BacktopButton'
    export default {
        name: 'IndustryMain',
        components: {
            Navbar,
            Header,
            IndustryContent,
            FooterTop,
            FooterBottom,
        },
        data() {
            return {
                bannerTitle: this.$t('navbar.menu_5'),
                borrowSpaceCrumb: [
                    {
                        name: this.$t('navbar.menu_5'),
                        path: "/industry"
                    }
                ]
            }
        }
    }
</script>
